<div class="w-full font-work-sans content-section font-regular prose" [innerHTML]="data?.content">
</div>